<template>
    <div id="page" class="page font--jakarta">
      <HeaderLayout1 />
      <slot />
      <FooterLayout2 />
    </div>
</template>

<style src="~/assets/css/color-scheme/pickleball.scss" lang="scss"></style>
